module.exports = __webpack_public_path__ + "img/downloadIcon.png";